import saleableServices from '@/mixins/services/saleableServices'
import routeControl from '@/mixins/routeControl'

export default {
  mixins: [saleableServices, routeControl ],
  props: ['type', 'productId', 'articleId'],
  data () {
    return {
      searchOptions: [],
      searchString: '',
      loading: false
    }
  },
  computed: {
    what () {
      throw new Error('Must be reimplemented')
    },
    showOptions () {
      /* let lst = this.searchOptions.map(opt => {
        if (typeof opt === 'string') {
          return {
            title: opt,
            subtitle: '',
            originalObject: opt
          }
        }
        return opt
      })
      if (this.searchString) {
        let str = this.searchString.toLowerCase()
        lst = lst.filter(opt => {
          return opt.title.toLowerCase().indexOf(str) > -1 || opt.subtitle.toLowerCase().indexOf(str) > -1
        })
      }
      return lst */
      if (this.searchString) {
        let str = this.searchString.toLowerCase()
        return this.searchOptions.filter(opt => {
          return opt.Label.toLowerCase().indexOf(str) > -1
        })
      }
      return this.searchOptions
    },
    nextQuestion () {
      let idx = this.buying.toBeAsked.indexOf(this.what)
      return this.buying.toBeAsked[idx + 1]
    },
    isCSC() {
      return this.type === 'csc'
    },
    isEticket() {
      return this.type === 'eticket'
    }
  },
  methods: {
    saveParameter () {
      throw new Error('Must be reimplemented')
    },
    next (opt) {
      // console.log('next', opt)
      this.saveParameter(opt)
      if (this.nextQuestion) {
        this.goTo('/products/' + this.type + '/' + this.productId + '/' + + this.articleId + '/' + this.nextQuestion, true)
      } else { // qui non entrerà mai
        this.cartSize += this.test
        this.goTo('/cart')
      }
    },
    getData () {
      let max = 5 + Math.random() * 25
      for (let i = 0; i < max; i++) {
        this.searchOptions.push(Math.random() > 0.25 ? 'Option ' + (i + 1) : { title: 'Option ' + (i + 1), subtitle: 'Sottotitolo' })
      }
    }
  },
  mounted () {
    if (!this.buying) {
      this.goTo('/', true)
    }
  },
  watch: {
    '$route.params': {
      handler() {
        if (!this.buying) {
          setTimeout(this.back, 20) // this.goTo('/products/new', true)
          // console.log('!this.buying')
          return
        }
        this.searchString = ''
        this.loading = true
        this.getData().then(data => {
          // console.log('data', data)
          this.loading = false
          data.forEach(dt => {
            if (dt.Label) {
              dt.Label = dt.Label.trim()
            }
          })
          data.sort((a, b) => a.Label > b.Label ? 1 : -1)
          this.searchOptions = data
        }).catch(e => {
          console.warn(e)
          this.internalBus.$emit('notify:error', {
            text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : ''),
            key: this.notifierKey
          })
          this.back()
        })
      },
      immediate: true
    }
  }
}
